import axios from 'axios';

import { UnauthorizedType } from '../types/UnauthorizedType';
import { MessageFormType } from '../types/MessageFormType';
import headers from '../headers.json';
import { MessageResultType } from '../types/MessageResultType';

type SuccessType = {
  success: boolean;
  message: string;
  data: MessageResultType;
};

type PromiseType =
  | { data: SuccessType; success: boolean }
  | { data: UnauthorizedType; success: boolean }
  | { data: null; success: boolean };

const POST_MANUAL = async (data: MessageFormType): Promise<PromiseType> => {
  try {
    const serverUrl = process.env.REACT_APP_SERVER_URL_BACKEND_API;
    if (!serverUrl) throw Error('Backend-URL not defined.');

    const url = `${serverUrl}/generate/submit-form`;

    const response = await axios.post<SuccessType | UnauthorizedType>(url, data, {
      headers: {
        ...headers,
      },
      withCredentials: true,
    });

    if (response.data.success) {
      return { success: true, data: response.data };
    }

    return { success: false, data: response.data };
  } catch (error) {
    console.error(error);

    return { success: false, data: null };
  }
};

export default POST_MANUAL;
